import {
  styled,
  TextField,
} from "@mui/material";
import LightTooltip from "controls/global/light-tooltip";
import React, {
  useEffect,
  useRef,
  useState,
} from "react";
import theme from "theme/default";
import { colors } from "theme/defaultStyle";

interface IProps {
  label?: string | undefined;
  name: any;
  type?: string;
  value?: any;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<any>) => void;
  onBlur?: any;
  className?: any;
  inputProps?: any;
  InputProps?: any;
  hasError?: boolean;
  fieldRef?: any;
  multiline?: boolean;
  placeholder?: string;
  rows?: number;
  size?: "small" | "medium";
  maxLength?: number;
  style?: React.CSSProperties;
}

const CssTextField = styled(TextField)({
  "& input.MuiInputBase-input": theme.custom.textField.inputOutlined,
  "& input.MuiInputBase-input.Mui-disabled":
    theme.custom.textField.inputOutlinedDisabled,
  // backgroundColor: colors.grey10,
  "& div.MuiInputBase-root.MuiInputBase-adornedEnd.Mui-disabled": {
    backgroundColor: colors.grey10,
  },
  "& .MuiOutlinedInput-root.Mui-disabled": {
    backgroundColor: colors.grey10,
  },
});

const TextInput = ({
  label,
  name,
  type,
  value,
  disabled = false,
  onChange,
  onBlur,
  className,
  inputProps,
  InputProps,
  hasError = false,
  fieldRef,
  multiline = false,
  rows,
  placeholder,
  size = "medium",
  maxLength,
  style,
}: IProps) => {
  const [shrinkable, setShrinkable] = useState<boolean>(false);
  const [openTooltip, setOpenTooltip] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const onMouseEnter = () => {
    handleOpenTooltip(true);
  };
  const onMouseLeave = () => {
    handleOpenTooltip(false);
  };

  const handleOpenTooltip = (isMouseEnter: boolean) => {
    const isInRangeAndOverflowed =
      isMouseEnter &&
      inputRef &&
      inputRef.current &&
      inputRef.current.children &&
      inputRef.current.children.length > 1 &&
      inputRef.current.children[1].children &&
      inputRef.current.children[1].children.length > 0;

    if (isInRangeAndOverflowed) {
      const scrollWidth =
        inputRef?.current?.children[1].children[0].scrollWidth || 0;
      const clientWidth =
        inputRef.current?.children[1].children[0].clientWidth || 0;
      const isScrollPresent = scrollWidth > clientWidth + 2;
      setOpenTooltip(isScrollPresent);
    } else {
      setOpenTooltip(false);
    }
  };

  const handleOnBlur = (event: React.ChangeEvent<any>) => {
    if (!event.target.value && !hasError) setShrinkable(false);
    onBlur && onBlur(event);
  };

  const handleOnChange = (e: any) => {
    if (!e.target.value) setShrinkable(false);
    else setShrinkable(true);
    onChange && onChange(e);
  };

  const handleOnFocus = () => setShrinkable(true);

  useEffect(() => {
    (hasError || value) && setShrinkable(true);
    !hasError && !value && setShrinkable(false);
  }, [hasError, value]);

  return (
    <LightTooltip
      title={value || ""}
      open={openTooltip}
      arrow
      //TODO REVIEW MUI5
      //interactive={false}
      disableFocusListener={true}
    >
      <CssTextField
        {...{ type }}
        id={name}
        name={name}
        label={label}
        onChange={handleOnChange}
        disabled={disabled}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
        fullWidth
        value={value || ""}
        inputProps={{
          name,
          "aria-errormessage": hasError ? "rhfvalidationerror" : "",
          maxLength,
          ...inputProps,
        }}
        //InputProps={{ ...inputProps, disableUnderline: true }}
        InputProps={{ ...InputProps, disableUnderline: true }}
        InputLabelProps={{
          shrink: shrinkable,
        }}
        className={className}
        ref={inputRef}
        onMouseEnter={() => onMouseEnter()}
        onMouseLeave={() => onMouseLeave()}
        error={hasError}
        inputRef={fieldRef}
        multiline={multiline}
        placeholder={placeholder}
        rows={rows}
        variant="outlined"
        size={size}
        sx={{ ...style }}
      />
    </LightTooltip>
  );
};

export default TextInput;
